<template>
    <div>
        <div class="level">
            <div class="level-left">
                <div class="buttons level-item">
                    <button
                        v-if="
                            selectedFilter !==
                            $t('Constants.FILTER_OPTION_SESSION_ALL')
                        "
                        v-t="'Dashboard.show_all'"
                        class="button is-primary"
                        @click="
                            selectedFilter = $t(
                                'Constants.FILTER_OPTION_SESSION_ALL'
                            )
                        "
                    ></button>
                    <AppDropdownFilter
                        :filter.sync="selectedFilter"
                        :active="dropdownActive"
                        :options="dropdownOptions"
                        @click="dropdownActive = !dropdownActive"
                    />
                </div>
            </div>
            <div class="level-right">
                <div class="level-left">
                    <div class="field has-addons lb-search-bar is-expanded">
                        <p
                            class="control has-icons-left lb-clean-input is-expanded"
                        >
                            <input
                                :value="value"
                                :placeholder="$t('search')"
                                class="input"
                                type="text"
                                @input="$emit('input', $event.target.value)"
                            />
                            <span class="icon is-small is-left">
                                <i class="mdi mdi-24px mdi-magnify"></i>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppDropdownFilter from '@/components/AppDropdownFilter';
export default {
    components: {
        AppDropdownFilter,
    },
    props: {
        filter: {
            type: String,
            default: undefined,
        },
        value: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            dropdownActive: false,
            selectedFilter: this.filter,
            dropdownOptions: [
                this.$t('Constants.FILTER_OPTION_SESSION_ALL'),
                this.$t('Constants.FILTER_OPTION_SESSION_TRIVIAL'),
                this.$t('Constants.FILTER_OPTION_SESSION_TREASUREHUNT'),
            ],
        };
    },
    watch: {
        selectedFilter() {
            this.$emit('update:filter', this.selectedFilter);
        },
    },
};
</script>

<style scoped></style>
